import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from "@angular/core";
import { BillingService } from "../billing.service";
import { LoggerService } from "@teammood/shared/util/logger";
import { catchError, EMPTY, Subject, takeUntil, tap } from "rxjs";
import { YearlySubscription } from "../billing.type";

@Component({
    selector: "yearly-billing",
    templateUrl: "./yearly-billing.component.html",
    providers: [
        BillingService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class YearlyBillingComponent implements OnInit, OnDestroy {
    protected subscription: YearlySubscription;

    private _destroy$ = new Subject<void>();
    protected loading: boolean = true;

    constructor(
        private logger: LoggerService,
        private billingService: BillingService,
    ) {}

    ngOnInit(): void {
        this.billingService.get_yearly_subscription().pipe(
            tap((subscription: YearlySubscription) => {
                this.subscription = subscription;
                this.loading = false;
            }),
            catchError(err => {
                this.logger.error('error getting yearly subscription infos', err);
                return EMPTY;
            }),
            takeUntil(this._destroy$)
        ).subscribe();
    }

    ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }

}